import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper, IconButton} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import Error from "../../common/Error/Error";
import ContentAdd from 'material-ui/svg-icons/content/add';
import style from "../../../styles/styles";
import {white} from "material-ui/styles/colors";
import PushElement from "../PushElement/PushElement";
import withTranslation from "../../../hoc/withTranslation";

class PushElementList extends React.Component {

    static propTypes = {
        title: PropTypes.string,
        handleAddPushElement: PropTypes.func,
        handleRemovePushElement: PropTypes.func
    };

    static defaultProps = {
        loading: false,
        elements: []
    };

    // Render

    render() {
        const {loading, elements, title, app, user} = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false}/>;
        } else if (elements.length === 0) {
            content =
                <Error
                    title={this.props.t('generic.no_data')}
                    subtitle={this.props.t('generic.add_some_element')}
                />
        } else {
            content = elements.map((element, index) => {
                return (
                    <div key={element}>
                        <PushElement
                            handleRemovePushElement={this.props.handleRemovePushElement}
                            user={user}
                            app={app}
                            element={element}
                        />
                        {index !== (elements.length - 1) && <Divider inset={true}/>}
                    </div>
                )
            })
        }

        return (
            <div>
                <Paper>
                    <List>
                        <Subheader style={{...style.subHeader, ...style.relative}}>
                            {title}
                            {this.props.handleAddPushElement && (
                                <IconButton
                                    onClick={this.props.handleAddPushElement}
                                    style={style.float.right}
                                    tooltip={this.props.t('settings_page.new_element')}
                                    tooltipPosition='top-center'
                                >
                                    <ContentAdd color={white}/>
                                </IconButton>
                            )}
                        </Subheader>

                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

export default withTranslation(PushElementList);



// WEBPACK FOOTER //
// src/components/push/PushElementList/PushElementList.js